import React, { useEffect, useState } from "react";
import "./Manufacturers.css";
import { useNavigate } from "react-router-dom";
import { Add, Close, DeleteOutline, Search } from "@mui/icons-material";
import {
  Autocomplete,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  IconButton,
  Paper,
  TextField,
} from "@mui/material";
import { RightOutlined } from "@ant-design/icons";
import { EditIcon } from "lucide-react";
import { DataGrid } from "@mui/x-data-grid";
import { Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import { newHost } from "../Categories/CategoryProfile";
import { toast } from "react-toastify";
import DeleteModal from "../../components/Modals/DeleteModal";
import { useSelector } from "react-redux";
import { newImageUrl } from "./ManufactureProfile";
import defaultImage from "../../assets/svg/defultImage.svg";

const Manufacturers = () => {
  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newHeaders = {
    Authorization: "Bearer " + token,
  };

  const [ManufactureValue, setManufactureValue] = useState(0);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [manufactures, setManufacturs] = useState([]);
  const [mainServices, setMainServices] = useState([]);
  const [manufactureId, setManufacureId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteManufacture, setDeleteManufacture] = useState(false);

  const Manufacturerscolumns = [
    {
      field: "reference",
      headerName: "Reference No.",
      flex: 1.3,
      minWidth: 180,
      renderCell: (params) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            wordBreak: "break-word",
            textAlign: "center",
            lineHeight: "18px",
            fontWeight: 600,
          }}
        >
          {params.row.reference || "-"}
        </div>
      ),
    },
    {
      field: "name",
      headerName: "Manufacturers Name",
      flex: 0.9,
      minWidth: 120,
    },
    {
      field: "categories",
      headerName: "Category",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => {
        const categoryImage = params.row?.categories || [];

        return categoryImage.map((category) => (
          <img
            style={{ width: "25px" }}
            src={`https://estbn.com/EstbnNew/public${category?.image_url}`}
            alt="category-image"
          />
        ));
      },
    },
    {
      field: "brands",
      headerName: "Brands No.",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => {
        return <p className="m-0"> {`${params.row?.brands?.length} brands`}</p>;
      },
    },
    {
      field: "created_by",
      headerName: "Created by",
      flex: 0.9,
      minWidth: 120,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        const handleEdit = (e, manufacture) => {
          setValue("name", manufacture.name);
          setValue("website_url", manufacture.website_url);
          setValue(
            "category_ids",
            manufacture.categories?.map((category) => category.id) || [],
          );
          setManufacureId(manufacture.id);
          setIsEdit(true);
          setShowModal(true);
          e.stopPropagation();
        };

        const handleNavigate = (event, id) => {
          event.stopPropagation();
          navigate(`/manufacturers/manufactureProfile/${id}`);
        };

        return (
          <div>
            <IconButton
              onClick={(e) => handleEdit(e, params.row)}
              color="default"
              aria-label="edit"
              size="small"
            >
              <EditIcon />
            </IconButton>
            <IconButton
              onClick={(e) => {
                handleDeleteManufactureShow(params.row?.id);
                e.stopPropagation();
              }}
              color="error"
              aria-label="delete"
              size="small"
            >
              <DeleteOutline />
            </IconButton>
            <IconButton
              onClick={(e) => handleNavigate(e, params.row?.id)}
              color="default"
              aria-label="navigate"
              size="small"
            >
              <RightOutlined />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const paginationModel = { page: 0, pageSize: 10 };

  const handleAddManufactureShow = () => {
    setIsEdit(false);
    setShowModal(true);
  };

  const handleAddManufactureClose = () => {
    reset({
      name: "",
      website_url: "",
      category_ids: [],
    });
    setIsEdit(false);
    setShowModal(false);
  };

  const handleDeleteManufactureShow = (id) => {
    setDeleteManufacture(true);
    setManufacureId(id);
  };

  const handleDeleteManufactureClose = () => {
    setDeleteManufacture(false);
  };

  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const getAllManufactures = async (categoryId = null) => {
    try {
      const url = categoryId
        ? `${newHost}portal/manufacturers?category_ids[]=${categoryId}`
        : `${newHost}portal/manufacturers`;

      const response = await axios.get(url, {
        headers: newHeaders,
      });
      console.log(response);
      setManufacturs(response.data.data?.manufacturers);
    } catch (error) {
      console.log(error);
    }
  };

  const getMainCategories = async () => {
    try {
      const response = await axios.get(`${newHost}portal/categories`, {
        headers: newHeaders,
      });
      setMainServices(response.data.data.categories);
    } catch (error) {
      console.log(error);
    }
  };

  const submitCreateManufacture = async (data) => {
    console.log(data);
    if (isEdit) {
      try {
        const response = await axios.post(
          `${newHost}portal/manufacturers/${manufactureId}`,
          {
            ...data,
            _method: "PATCH",
          },
          {
            headers: newHeaders,
          }
        );
        console.log(response);
        toast.success(response.data.data.message);
        reset({
          name: "",
          website_url: "",
          category_ids: [],
        });
        getAllManufactures();
        setShowModal(false);
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message);
      }
    } else {
      try {
        const response = await axios.post(
          `${newHost}portal/manufacturers`,
          data,
          {
            headers: newHeaders,
          }
        );
        console.log(response);
        toast.success(response.data.data.message);
        reset({
          name: "",
          website_url: "",
          category_ids: [],
        });
        getAllManufactures();
        setShowModal(false);
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message);
      }
    }
  };

  const handleDeleteManufacture = async () => {
    try {
      const response = await axios.delete(
        `${newHost}portal/manufacturers/${manufactureId}`,
        {
          headers: newHeaders,
        }
      );
      console.log(response);
      toast.success(response.data.data.message);
      getAllManufactures();
      setDeleteManufacture(false);
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    getAllManufactures();
    getMainCategories();
  }, []);

  const navigationItems = [{ name: "All", id: null }, ...mainServices];

  return (
    <>
      <DeleteModal
        showDelete={deleteManufacture}
        handleDeleteClose={handleDeleteManufactureClose}
        textMessage={" Are you sure you want to delete this Manufacture?"}
        deleteFunction={handleDeleteManufacture}
      />
      <Modal show={showModal} onHide={handleAddManufactureClose}>
        <Modal.Header style={{ backgroundColor: "#D5D5D5" }} closeButton>
          <Modal.Title>
            {isEdit ? "Update Manufacture" : "Add New Manufacturer"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(submitCreateManufacture)}>
            <div className="my-1">
              <label className="my-1" htmlFor={"name"}>
                Name
              </label>
              <TextField
                id="name"
                size="small"
                className="w-100"
                type="text"
                placeholder="Add Manufacturer Name"
                {...register("name")}
              />
            </div>
            <div className="my-1">
              <label className="my-1" htmlFor="location">
                Website (URL)
              </label>
              <TextField
                id="location"
                size="small"
                className="w-100"
                type="text"
                placeholder="Add Website (URL)"
                {...register("website_url")}
              />
            </div>
            <div className="my-1">
              <label className="my-1" htmlFor="category">
                Category
              </label>
              <Controller
                name="category_ids"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    multiple
                    size="small"
                    disableCloseOnSelect
                    className="w-100"
                    id="category"
                    value={mainServices.filter((s) =>
                      (field.value || []).includes(s.id),
                    )}
                    onChange={(e, newValue) => {
                      field.onChange(newValue.map((v) => v.id));
                    }}
                    options={mainServices}
                    getOptionLabel={(option) => option.name}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => {
                        const tagProps = getTagProps({ index });

                        return (
                          <span
                            {...tagProps}
                            key={option.id}
                            className="d-flex align-items-center mx-1"
                            style={{
                              padding: "2px 6px",
                              borderRadius: "12px",
                              backgroundColor: "#e0e0e0",
                              fontSize: "0.8rem",
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <img
                              src={
                                option.image_url
                                  ? newImageUrl + option.image_url
                                  : defaultImage
                              }
                              alt=""
                              style={{
                                width: 18,
                                height: 18,
                                borderRadius: "50%",
                              }}
                            />

                            <span>{option.name}</span>

                            <span
                              onClick={tagProps.onDelete}
                              style={{
                                cursor: "pointer",
                                fontSize: "12px",
                                lineHeight: 1,

                                color: "#555",
                              }}
                            >
                              <Close sx={{ color: "red", fontSize: "16px" }} />
                            </span>
                          </span>
                        );
                      })
                    }
                    renderOption={(props, option, state) => (
                      <li
                        {...props}
                        className="custom-menu-item"
                        style={{
                          padding: "10px 12px",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          margin: "5px",

                          backgroundColor: state.selected
                            ? "rgba(193, 203, 213, 0.15)"
                            : state.hovered
                              ? "rgba(175, 175, 175, 0.06)"
                              : "transparent",

                          borderRadius: "6px",
                        }}
                      >
                        <img
                          src={
                            option?.image_url
                              ? newImageUrl + option?.image_url
                              : defaultImage
                          }
                          alt=""
                          style={{
                            width: 22,
                            height: 22,
                            borderRadius: "50%",
                          }}
                        />

                        <div className="label-size m-0">{option.name}</div>
                      </li>
                    )}
                    ListboxProps={{
                      style: {
                        maxHeight: 220,
                        overflowY: "auto",
                        padding: "6px",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField placeholder="Select Category" {...params} />
                    )}
                  />
                )}
              />
            </div>
            <div className="d-flex gap-4 justify-content-center align-items-center  py-4">
              <button
                type="reset"
                className="px-5 py-2 btn btn-light"
                onClick={handleAddManufactureClose}
              >
                Cancel
              </button>
              <button className="px-5 py-2 btn btn-dark">Save</button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <div className="min-vh-100 m-4">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="fw-semibold m-0">Manufacturers</h5>
          <button onClick={handleAddManufactureShow} className="btn btn-light">
            {" "}
            <Add /> Add New Manufacturers{" "}
          </button>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <Box className="my-3">
            <BottomNavigation
              showLabels
              value={ManufactureValue}
              onChange={(event, newValue) => {
                setManufactureValue(newValue);
                const selectedCategoryId = navigationItems[newValue].id;
                getAllManufactures(selectedCategoryId);
              }}
              className="rounded-3 border d-flex align-items-center manufacture-navigation-buttons "
            >
              {navigationItems.map((category, index) => (
                <BottomNavigationAction
                  key={category.id || "all"}
                  className="BottomNavigationAction"
                  label={category.name}
                />
              ))}
            </BottomNavigation>
          </Box>
          <div className="d-flex justify-content-end align-items-center w-25  position-relative">
            <input
              type="text"
              placeholder="Search for manufacturer name"
              className="form-control px-3 w-100"
            />
            <Search sx={{ position: "absolute", marginInline: "3px" }} />
          </div>
        </div>
        <div>
          <Paper sx={{ height: "auto", width: "100%" }}>
            <DataGrid
              rows={manufactures}
              columns={Manufacturerscolumns}
              initialState={{ pagination: { paginationModel } }}
              pageSizeOptions={[5, 10, 15]}
              sx={{
                border: 0,
                "& .MuiDataGrid-cell": {
                  display: "flex",
                  justifyContent:'center',
                  alignItems: "center",
                },
              }}
            />
          </Paper>
        </div>
      </div>
    </>
  );
};

export default Manufacturers;
